import useComponentDidMount from 'Hooks/useComponentDidMount';
import { useOnboardingHeaderContext } from 'Views/Onboarding/Contexts/OnboardingHeaderContext';

export default function useDarkHeaderTheme(forceLightHeader = false) {
  const { handleSetHeaderThemeLight, handleSetHeaderThemeDark } = useOnboardingHeaderContext();

  useComponentDidMount(() => {
    if (forceLightHeader) {
      return;
    }
    handleSetHeaderThemeDark();
  }, () => {
    handleSetHeaderThemeLight();
  });
}
